import OrganisationFormLayout, { transformValues } from './form'
import GenericCreateForm from '../common/create'

export default () => (
  <GenericCreateForm formLayoutComponent={<OrganisationFormLayout />} transformValues={transformValues} />
)
